module.exports = {
    en: {
        vin: {
            company: 'INTERNATIONAL SHIPPING COMPANY',
            info: 'Vehicle information',
            code: "Enter VIN code or Enter container number",
            title1: "VIN code",
            title2: "Container number",
            plholder1: "Enter VIN code",
            plholder2: "Enter container number",
            search: "Search",
        }

    },
    ka: {
        vin: {
            company: 'საერთაშორისო გადაზიდვების კომპანია',
            info: 'ინფორმაცია მანქანის შესახებ',
            code: "შეიყვანეთ VIN კოდი ან კონტეინერის ნომერი",
            title1: "VIN კოდი",
            title2: "კონტეინერის ნომერი",
            plholder1: "შეიყვანეთ VIN კოდი",
            plholder2: "შეიყვანეთ კონტეინერის ნომერი",
            search: "ძიება",
        }
    },
    ru: {
        vin: {
            company: 'МЕЖДУНАРОДНАЯ СУДОХОДНАЯ КОМПАНИЯ',
            info: 'Информация об автомобиле',
            code: "Введите VIN-код или введите номер контейнера",
            title1: "VIN-код",
            title2: "Номер контейнера",
            plholder1: "Введите VIN-код",
            plholder2: "Введите номер контейнера",
            search: "Поиск",
        }
    }
}